import React from "react";
import "../styles/vision.css";
export default function Team() {
  return (
    <>
      <div className="textAlign container">
        <h1 className="containerH1">Team</h1>
        <ul>
          <li>
            <strong>Manu Sheel Gupta</strong>: (Email:{" "}
            <a href="mailto:manu@seeta.in">manu@seeta.in</a>) - Manu is the
            software architect and full stack engineer in the project. He is
            responsible both operationally and strategically to enable
            sustaining and scaling the project. He is also responsible for
            developing collaborations in the Blockchain eco-system and managing
            the project roadmap, milestones along with the feature spec and code
            freeze timelines.
          </li>
          <br />
          <li>
            <strong>Deepti Gupta</strong>: (Email:{" "}
            <a href="mailto:deepti.kotwal.2011@gmail.com">
              deepti.kotwal.2011@gmail.com
            </a>
            ) - Deepti brings years of experience of developing mobility
            solutions at SAP and is responsible for the UI/UX design, workflows,
            recommending key methods to effectively utilize the strengths of OP,
            IPFS.
          </li>
          <br />
          <li>
            <strong>Vibhor Bijoy</strong>: (Email:{" "}
            <a href="mailto:bijoy.vibhor19@gmail.com">
              bijoy.vibhor19@gmail.com
            </a>
            ) - Vibhor is our expert on developing security solutions,
            compliance software. With multiple years of experience at Thales
            (https://www.thalesgroup.com), he will enable us to go live. He will
            also enable us to do a pilot project at IIT Delhi.
          </li>
          <br />
          <li>
            <strong>Dr M.P.S. Bhatia</strong>: (Email:{" "}
            <a href="mailto:aspiringuserapps@gmail.com">
              aspiringuserapps@gmail.com
            </a>
            ) - Dr MPS Bhatia is the key enabler on piloting this project at
            Delhi. He is our go to mentor on building business partnerships with
            Ministry of Health.
          </li>
          <br />
          <li>
            <strong>Praveen Patel</strong>: (Email:{" "}
            <a href="mailto:android.seeta.dev@gmail.com">
              android.seeta.dev@gmail.com
            </a>
            ) - Praveen is our support and logistics executive, who looks after
            maintenance and support efforts.
          </li>
          <br />
          <li>
            <strong>Usha Gupta</strong>: (Email:{" "}
            <a href="mailto:seeta.team@gmail.com">seeta.team@gmail.com</a>) -
            UI/UX Tester and Design Expert
          </li>
          <br />
          <li>
            <strong>Arvind Kumar Gupta</strong>: (Email:{" "}
            <a href="mailto:arvindsenior@gmail.com">arvindsenior@gmail.com</a>)
            - Business Development and Strategic Guidance
          </li>
          <br />
          <li>
            <strong>Rakhee</strong>: (Email:{" "}
            <a href="mailto:financeseeta@gmail.com">financeseeta@gmail.com</a>)
            - OP Developer Support and Regional Community Volunteer
          </li>
          <br />
          <li>
            <strong>Vithika Gupta</strong>: (Email:{" "}
            <a href="mailto:aspiringworkapps@gmail.com">
              aspiringworkapps@gmail.com
            </a>
            ) - OP Analytics and Community Tooling Developer
          </li>
          <br />
          <li>
            <strong>Pradhuman Chhabra</strong>: (Email:{" "}
            <a href="mailto:pradhumanchhabra1999@gmail.com">
              pradhumanchhabra1999@gmail.com
            </a>
            ) - Design and develop Web3 tools and platforms
          </li>
          <br />
        </ul>
      </div>
    </>
  );
}
